import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

interface CountryButtonProps {
  selected: boolean;
}

interface CountryFlagProps {
  imageUrl: string;
}

export const CountryContainer = styled.div`
  display: grid;
  grid-template-rows: 1fr;
  grid-gap: 12px;
`;

export const CountryButton = styled.button<CountryButtonProps>`
  display: flex;
  align-items: center;

  height: 75px;

  background: none;
  border: 1px solid ${({ selected }) => (selected ? ColorPalette.HEX.BrightOrange : ColorPalette.HEX.LavenderGray)};
  border-radius: 8px;
  transition: border-color ease-in-out 0.2s;
  cursor: pointer;
`;

export const CountryFlag = styled.div<CountryFlagProps>`
  width: 32px;
  height: 32px;
  margin: 32px;
  border-radius: 50%;

  background-image: url(${({ imageUrl }) => imageUrl});
  background-size: 32px;
  background-position: center;
`;

export const CountryName = styled.span`
  font-size: 18px;
  line-height: 24px;
  color: ${ColorPalette.HEX.DimGray};
`;
